import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { OrganisationService } from './organisation.service';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { User } from '../models/response-models/user';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoginService } from './login.service';
import { AlertSettings, AlertType } from '../alert/alert.service';
import { ErrorHandlerService } from './error-handler.service';
import { PermissionService } from './permission.service';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from './mixpanel.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  loadingRouteConfig: boolean;
  routerEventSubscription: Subscription;

  userInfo: User;
  userError: AlertSettings;

  constructor(
    private organisationService: OrganisationService,
    private router: Router,
    private http: HttpClient,
    private loginService: LoginService,
    private errorHandlerService: ErrorHandlerService,
    private permissionService: PermissionService,
    public translate: TranslateService,
    private mixpanel: MixpanelService 
  ) {

  }

  init() {
    return new Promise<void>((resolve) => {
      this.subscribeOnLazyLoad();

      this.loadUserProfile(()=>{
        this.loginService.loadPermissions(true, ()=>{
          resolve();
        });
      });
    });
  }

  loadUserProfile(callback?: (user?: User)=>void){
    if(this.loginService.isLoggedIn()){
      this.getUserProfile().subscribe({
        next: (response: User)=>{
          this.userInfo = response;
          this.organisationService.organisation = this.userInfo.organisation;
         
          if(this.userInfo.permissions && this.userInfo.permissions.length) this.permissionService.permissions = this.userInfo.permissions;
          this.mixpanel.identifyUser(this.userInfo);
          if(callback) callback(response);
        },
        error: (error: any)=>{
          this.errorHandlerService.handleError(error, (message: string)=>{
            this.userError = {
              class: AlertType.ERROR,
              message: message
            }
          });
          if(callback) callback();
        }
      })
    } else {
      if(callback) callback();
    }
  }

  getUserProfile(): Observable<User>{
    return this.http.get<User>(environment.serverUrl + "/users/profile");
  }

  subscribeOnLazyLoad(){
    this.routerEventSubscription = this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });
  }
}
